
import React from 'react';
import {
  UserContent, UserContentFolder,
  TrackContent,
  CollaborativeMap, AppUser
} from '../../types';
import MyContentInner from './MyContentInner';
import type { TabKey } from '../../types/sidebar';

interface MyContentPanelProps {
  isOpen: boolean;
  onClose: () => void;
  content: UserContent[];
  folders: UserContentFolder[];
  isPaidUser: boolean;
  userId?: string;
  initialTab?: TabKey;
  onFlyToContent?: (bounds: { latMin: number; latMax: number; lonMin: number; lonMax: number }) => void;
  onShowContentOnMap?: (items: UserContent[]) => void;
  onStartDrawing?: (mode: 'line' | 'area') => void;
  onViewTrack?: (track: TrackContent) => void;
  onShowNudge?: (key: 'drawing_tools' | 'content_folders') => void;
  collaborativeMaps?: CollaborativeMap[];
  currentUser?: AppUser | null;
  onOpenCollabMap?: (mapId: string) => void;
  onShowCollabMapOnMap?: (mapId: string) => void;
  onCreateCollabMap?: () => void;
  spotPhotos?: Map<string, string>;
  onWaypointsPublished?: (spots: import('../../types').CampingSpot[]) => void;
}

const MyContentPanel: React.FC<MyContentPanelProps> = ({
  isOpen, onClose, ...rest
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

      <div className="relative w-full sm:max-w-md bg-[var(--bg-surface)] rounded-t-3xl sm:rounded-3xl border border-[var(--border-secondary)] shadow-2xl h-[85dvh] sm:h-[75vh] flex flex-col overflow-hidden" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <MyContentInner
          {...rest}
          isVisible={isOpen}
          onClose={onClose}
          showCloseButton={true}
        />
      </div>
    </div>
  );
};

export default MyContentPanel;
